import React, { useEffect, useState } from 'react';
import { ApiRequest } from 'GlobalFunctions';
import Conversation from './Conversation';
import { useParams } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { IoChatbubblesOutline } from "react-icons/io5";
import EmptyElement from 'elements/EmptyElement';
import Filters from 'elements/Filters/Filters';
import FiltersApplied from 'elements/Filters/FiltersApplied';
import TuneIcon from '@mui/icons-material/Tune';
import Button from '@mui/material/Button';
import NewMessageDialog from './NewMessageDialog';

const drawerWidth = 240;

const filters = [
  {type: "text", label: "Email", name: "email", value: ""},
  {type: "text", label: "Nombre", name: "name", value: ""},
  {type: "text", label: "Apellido", name: "lastname", value: ""},
];

export default function MessagesList(props:any) {
  const {conversation_id} = useParams<{conversation_id: string}>();

  const savedFilters = localStorage.getItem('messageFilters') || "{}";
  const [filtersValues, setFiltersValues] = useState<any>(() => {
    try { return JSON.parse(savedFilters); } catch { return {}; }
  });
  const [conversations, setConversations] = useState<any[]>([]); // Inicializamos como arreglo vacío
  const [selectedConversationId, setSelectedConversationId] = useState<string | null>(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [open, setOpen] = useState(false);
  const [openNewMessage, setOpenNewMessage] = useState(false);

  const setFilters = (tempFilters: any) => {
    setFiltersValues(tempFilters);
    localStorage.setItem('messageFilters', JSON.stringify(tempFilters));
  };

  const loadList = async () => {
    await ApiRequest({
      url: '/messages/globalConversations',
      method: 'GET',
      query: {
        filters: filtersValues,
      },
      setResponse: (response: any) => {
        setConversations(response.conversations || []); // Si no hay conversaciones, usa arreglo vacío
      },
    });
  };

  useEffect(() => {
    loadList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersValues]);

  useEffect(() => {
    if (conversation_id) {
      setSelectedConversationId(conversation_id);
    }
  }, [conversation_id]);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false); 
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const drawer = (
    <div>
      <Divider />
      
      <div style={{ display: 'flex', alignItems: 'center', padding: '20px' }}>
            <h3 style={{ flexGrow: 1 }}>Conversaciones</h3>
            <IconButton
              color="inherit"
              aria-label="filter"
              onClick={() => setOpen(true)}
            >
              <TuneIcon />
            </IconButton>
            
            
            
          </div>
          <div className='massive_actions'>
            <Button variant="contained" onClick={() => setOpenNewMessage(true)}>
              Nuevo Mensaje
            </Button>
          </div>
          
          <FiltersApplied filtersValues={filtersValues} setFiltersValues={setFiltersValues} />
      {conversations.length > 0 ? (
      <List>
          
          

            {conversations.map((conversation: any, index: number) => (
              <ListItem key={index} disablePadding>
                <ListItemButton onClick={() => setSelectedConversationId(conversation.conversation_id)}>
                  <ListItemIcon>
                  <IoChatbubblesOutline size={30} style={{ color: '#C8C5C5' }} />
                  </ListItemIcon>
                  <div className='admin_conversation_item'>
                    <div>{conversation.user_name_1 + ' ' + conversation.user_lastname_1}</div>
                    <div>{conversation.user_name_2 + ' ' + conversation.user_lastname_2}</div>
                  </div>
                </ListItemButton>
              </ListItem>
            ))}

      </List>
      ) : (
        <EmptyElement title='No hay conversaciones' />
      )}

      
            
    </div>
  );

  return (
    <>
    
    <div id='messages_content' className='content'>
      <div id='messages_container'>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <CssBaseline />
          <AppBar
            position="static"
            sx={{
              width: '100%',
              display: { xs: mobileOpen ? 'none' : 'block', sm: 'none' }
            }}
          >
            
            <Toolbar>
              
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" noWrap component="div">
                Mensajes
              </Typography>
            </Toolbar>
          </AppBar>
          <Filters open={open} setOpen={setOpen} filters={filters} setFilters={setFilters} />
          
          <Box sx={{ height: '100%', display: 'flex' }}>
            <Box
              component="nav"
              sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
              aria-label="mailbox folders"
            >
              {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
              <Drawer
                variant="temporary"
                open={mobileOpen}
                onTransitionEnd={handleDrawerTransitionEnd}
                onClose={handleDrawerClose}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                  display: { xs: 'block', sm: 'none' },
                  '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
              >
                {drawer}
              </Drawer>
              <Drawer
                variant="permanent"
                sx={{
                  display: { xs: 'none', sm: 'block' },
                  '& .MuiDrawer-paper': { 
                    boxSizing: 'border-box', 
                    position: "absolute", 
                    width: drawerWidth },
                }}
                open
              >
                {drawer}
              </Drawer>
            </Box>

              <div className='conversation'>
                {selectedConversationId ? (
                  <Conversation conversationId={selectedConversationId} />
                ) : (
                  <div style={{ padding: '20px' }}>
                    <h3>Seleccione una conversación para ver los mensajes</h3>
                  </div>
                )}
              </div>
          </Box>
        </Box>
      </div>
    </div>

    <NewMessageDialog 
      open={openNewMessage} 
      onClose={() => setOpenNewMessage(false)} 
      loadList={loadList}
    />
    </>
  );
}




